// 代理秘书
export default {
    nav: [
        {
            title: '首页',
            href: '/',
            activeReg: /(^\/search*)|(^\/$)/,
        },
        {
            title: '新闻公告',
            href: '/news',
            activeReg: /(^\/news*)/,
        },
        {
            title: '交易信息',
            href: '/business',
            activeReg: /(^\/business*)/,
        },
        {
            title: '帮助中心',
            href: '/guide',
            activeReg: /(^\/guide*)/,
        },
        {
            title: '下载中心',
            href: '/download',
            activeReg: /(^\/download*)/,
        },
        {
            title: 'CA办理/续费',
            href: '/cahandle',
            activeReg: /(^\/cahandle*)/,
        },
        {
            title: '关于我们',
            href: '/about',
            activeReg: /(^\/about*)/,
        },
    ],
    head: {
        title: '代理秘书',//全称
        title2: '代理秘书',//简称
        jc_title: '代理秘书',//简称
        citycode:'0',//城市编号
        planName:'dlms',
        caType:'',
        meta: {
            description: '代理秘书,交易平台,招投标,电子交易平台',
            keywords: '代理秘书,交易平台,招投标,电子交易平台',
        },
        favicon: '/dlms/favicon.ico',
        logoUrl: '/dlms/images/logo.png',//首页LOGO
        loginImgUrl: '/dlms/images/logo.png',
        registerImg: '/dlms/images/logo.png',//注册页面LOGO
        bannerList:[
            {
                linkimg:'',
                linkurl:''
            }
        ],
        tbLoginUrl:'http://scjzztbtb.zchzb.com/#/login?plan=scjz',
        isNotZfcg: true,//没有政府采购
        // 用户角色登录
        userRoles: [
            {
                imgsrc: '/img/hzzlogin/zb.png',
                href: 'http://scjzztbdl.zchzb.com/otc/#/login?plan=scjz&mRole=agent',
                title: '代理机构登录',
                class: 'gcjs',
            },
            {
                imgsrc: '/img/hzzlogin/tb.png',
                href: 'http://scjzztbtb.zchzb.com/#/login?plan=scjz',
                title: '供应商登录',
                class: 'zfcg',
            },
            {
                imgsrc: '/img/hzzlogin/pb.png',
                href: 'http://scjzztbpb.zchzb.com/?plan=scjz',
                title: '专家登录',
                class: 'zj'
            },
            {
                imgsrc: '/img/hzzlogin/cg.png',
                href: 'http://scjzztbdl.zchzb.com/otc/#/login?plan=scjz&mRole=tender',
                title: '采购人登录',
                class: 'qycg',
            },
        ],
        friendLinks:[
            {
                href: 'https://www.hysware.com/',
                title: '宏业建设软件有限责任公司'
            },
            {
                href: 'http://www.cebpubservice.com/',
                title: '中国招投标公共服务平台'
            },
            {
                href: 'http://www.ccgp.gov.cn/',
                title: '中国政府采购网'
            },
            {
                href: 'https://www.creditchina.gov.cn/',
                title: '信用中国'
            },
            {
                href: 'https://wenshu.court.gov.cn/',
                title: '中国裁判文书网'
            },
            {
                href: '',
                title: ''
            },
            {
                href: '',
                title: ''
            },
        ],
        tel: '028-86917722', //客服电话
        tel2: '',//备用电话/其他电话
        fax: '028-86917755',//传真号码
        email: '', //邮箱地址
        workTime: '',//工作时间
        postalCode: '',//邮政编码
        companyName: '代理秘书',  //运营公司名称
        companyAddress: '四川省成都市青羊区敬业路218号8栋(青羊工业园区K8栋)',//公司地址
        companyLatLng:{ lng: 0, lat: 0 },//公司地址坐标
        showWeather: false,//是否显示天气
        icp:'蜀ICP备06011533号',
        gwIcp:'',
        products: [
            {
                title: 'xxxx',
                href: 'xxxxx'
            },
        ],
        isHiddenZiRanRen: false, //注册页面 用户类型是否隐藏自然人
        isCheckOtherSingleCertCode: true, //注册页面 是否校验 其他一证一照代码
    },
    proxy: {
        '/web': {
            target: 'http://scjzztb.com/',
            changeOrigin:true,
        },
    },
}